import './liquidcatering/style';
import FormStructure from './liquidcatering/form_structure';

export default FormStructure;